



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import XLSX from 'xlsx';

@Component
export default class ImportResult extends Vue {

  @Prop() unconnected!: any[]

  close() {
    this.$emit('close');
  }

  exportList() {
    const cols_props_10: any = {wch: 10, hpt: 15};
    const cols_props_25: any = {wch: 25, hpt: 15};

    const csvContent: any[] = [];
    csvContent.push(['Дата', 'Сумма', 'Плательщик', 'ИНН', 'Операция', 'Основание'])
    this.unconnected.map((item: any) => {
      console.log(item)
        const row: any[] = [];
        row.push(item.date)
        row.push(item.payment)
        row.push(item.payer)
        row.push(item.inn)
        row.push(item.operation)
        row.push(item.reasone)
        csvContent.push(row)
    })

    const ws = XLSX.utils.aoa_to_sheet(csvContent);
    ws["!cols"] = [
      cols_props_10, cols_props_10, cols_props_25, cols_props_10, cols_props_25, cols_props_25
    ];
    // @ts-ignore
    const range = XLSX.utils.decode_range(ws['!ref']);
    for(let R = range.s.r; R <= range.e.r; ++R) {

      for(let C = range.s.c; C <= range.e.c; ++C) {
        const cellref = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
        if(!ws[cellref] || C < 6 || R < 1) continue; // if cell doesn't exist, move on
        const cell = ws[cellref];
        cell.t = 'n'
        cell.z = '0.00'
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Платежи");
    XLSX.writeFile(wb, 'export.xlsx')
  }
}

